module.exports = __webpack_public_path__ + "static/media/down-arrow-red.53f112ec.svg";